import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  navigate(event) {
    event.preventDefault()
    const url = new URL(event.currentTarget.href)
    url.hash = window.location.hash
    window.location = url.toString()
  }
}
